import axios from "../axios-auth";
import orginal_axios from "axios";

export const productionOrderService = {
  getProductionOrderList,
  saveProductionOrder,
  getProductionOrderDetail,
  exportAllProductionOrderExcel
};

function getProductionOrderList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy,
  };

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.poNo) {
    params["poNo"] = searchParams.poNo;
  }
  if (searchParams.fromDepartmentId) {
    params["fromDepartmentId"] = searchParams.fromDepartmentId;
  }
  if (searchParams.toDepartmentId) {
    params["toDepartmentId"] = searchParams.toDepartmentId;
  }
  if (searchParams.productCode) {
    params["productCode"] = searchParams.productCode;
  }
  if (searchParams.productName) {
    params["productName"] = searchParams.productName;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.binId) {
    params["binId"] = searchParams.binId;
  }
  if (searchParams.productionType) {
    params["productionType"] = searchParams.productionType;
  }
  if (searchParams.stockWarehouseId) {
    params["stockWarehouseId"] = searchParams.stockWarehouseId;
  }
  if (searchParams.stockBinId) {
    params["stockBinId"] = searchParams.stockBinId;
  }
  if (typeof (searchParams.checkLocationMovement) == 'boolean') {
    params["checkLocationMovement"] = searchParams.checkLocationMovement;
  }
  if (typeof (searchParams.isAddDetails) == 'boolean') {
    params["isAddDetails"] = searchParams.isAddDetails;
  }
  if (typeof (searchParams.isAddUnits) == 'boolean') {
    params["isAddUnits"] = searchParams.isAddUnits;
  }
  if (searchParams.productionPlanNo) {
    params["productionPlanNo"] = searchParams.productionPlanNo;
  }

  return axios.get("/auth/production-orders", { params });
}

function saveProductionOrder(productionOrder) {
  if (!productionOrder.id) {
    // new productionOrder
    return axios.post("/auth/production-order", productionOrder);
  } else {
    // edit
    return axios.put("/auth/production-order", productionOrder);
  }
}

function getProductionOrderDetail(id) {
  return axios.get("/auth/production-order/" + id);
}

function exportAllProductionOrderExcel(searchParams) {
  let params = {};

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.poNo) {
    params["poNo"] = searchParams.poNo;
  }
  if (searchParams.fromDepartmentId) {
    params["fromDepartmentId"] = searchParams.fromDepartmentId;
  }
  if (searchParams.toDepartmentId) {
    params["toDepartmentId"] = searchParams.toDepartmentId;
  }
  if (searchParams.productCode) {
    params["productCode"] = searchParams.productCode;
  }
  if (searchParams.productName) {
    params["productName"] = searchParams.productName;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (typeof (searchParams.isAddDetails) == 'boolean') {
    params["isAddDetails"] = searchParams.isAddDetails;
  }
  if (searchParams.productionPlanNo) {
    params["productionPlanNo"] = searchParams.productionPlanNo;
  }

  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/production-order-excel-export",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}